/*
Defines the timeline for practice trials and main trials.
*/

import {
  initBlock,
  updateStimulus,
  numberMainTimer,
  numberMultichoiceTimer,
  practiceFeedbackCorrect,
  practiceFeedbackIncorrect,
  ifTimeoutFlash,
} from "./trialDefinitions";
import store from "store2"; //storing session data

const incorrectLoop = (corpusName, assessment_stage_val) => {
  return {
    timeline: [practiceFeedbackIncorrect(corpusName, assessment_stage_val)],
    on_timeline_start: () => {
      store.session.transact("indexTracking", (oldVal) => oldVal + 1);
    },
    loop_function: () => {
      store.session.transact("practiceIncorrectCount", (oldVal) => oldVal + 1);
      if (
        store.session.get("dataCorrect") === 1 ||
        store.session.get("practiceIncorrectCount") > 1
      ) {
        return false;
      }
      return true;
    },
  };
};

const ifIncorrect = (corpusName, assessment_stage_val) => {
  return {
    timeline: [incorrectLoop(corpusName, assessment_stage_val)],
    conditional_function: () => {
      if (store.session.get("dataCorrect") === 0) {
        return true;
      }
      return false;
    },
  };
};

const ifCorrect = {
  timeline: [practiceFeedbackCorrect],
  conditional_function: () => {
    if (
      store.session.get("dataCorrect") === 1 &&
      store.session.get("practiceIncorrectCount") < 2
    ) {
      return true;
    }
    return false;
  },
};

const practiceFeedbackLoop = (corpusName, assessment_stage_val) => {
  return {
    timeline: [ifIncorrect(corpusName, assessment_stage_val), ifCorrect],
  };
};

export const numberPracticeLoop = (corpusName, assessment_stage_val) => {
  return {
    timeline: [
      initBlock(corpusName),
      updateStimulus(),
      numberMainTimer(corpusName, assessment_stage_val),
      practiceFeedbackLoop(corpusName, assessment_stage_val),
    ],
    loop_function: function () {
      store.session.set("practiceIncorrectCount", 0);
      if (store.session.get("dataCorrect") === 1) {
        store.session.transact("practiceCorrect", (oldVal) => oldVal + 1);
      }
      if (store.session("currentCorpus").length === 0) {
        store.session.set("indexTracking", -1);
        store.session.set("correctCount", 0);
        return false;
      }
      return true;
    },
  };
};

export const numberMainOuterLoop = (corpusName, assessment_stage_val) => {
  return {
    timeline: [
      initBlock(corpusName),
      numberMainLoop(corpusName, assessment_stage_val),
    ],
    loop_function: () => {
      store.session.transact("arrayIdx", (oldVal) => oldVal + 1);

      if (
        store.session.get("arrayIdx") <
        store.session.get("timerDuration").length
      ) {
        if (store.session.get("correctCount") === 0) {
          return false;
        } else {
          store.session.set("correctCount", 0);
          return true;
        }
      } else {
        store.session.set("arrayIdx", 0);
        return false;
      }
    },
  };
};

const numberMainLoop = (corpusName, assessment_stage_val) => {
  return {
    timeline: [
      updateStimulus(),
      numberMainTimer(corpusName, assessment_stage_val),
      ifTimeoutFlash,
      //ifRealTrialResponse,
    ],
    on_timeline_start: () => {
      document.getElementById(
        "jspsych-progressbar-container",
      ).style.visibility = "visible";
    },
    loop_function: function () {
      if (
        store.session.get("timerStatus") &&
        (store.session("timeOut") ||
          store.session("currentCorpus").length === 0)
      ) {
        // repeat until either max trials is reached or if timer is complete
        store.session.set("indexTracking", -1);
        if (store.session.get("timeOut") === true) {
          store.session.set("allowKeyUp", true);
          store.session.set("timeOut", false);
        }
        store.session.set("timeForceOut", false);
        clearTimeout(store.session.get("timerId"));
        clearTimeout(store.session.get("timerForceId"));
        return false;
      } else if (
        !store.session.get("timerStatus") &&
        store.session("indexTracking") + 1 ===
          store.session.get("config").totalTrialsMain
      ) {
        store.session.set("indexTracking", -1);
        return false;
      }
      return true;
    },
  };
};
